export class SiteModel {
  id: number;
  cod: string;
  description: string;
  checked: boolean;


  constructor(id?: number, cod?: string, description?: string) {
    this.id = id;
    this.cod = cod;
    this.description = description;
  }
}
